import { render, staticRenderFns } from "./edit-article.vue?vue&type=template&id=73dc523e&scoped=true&"
import script from "./edit-article.vue?vue&type=script&lang=js&"
export * from "./edit-article.vue?vue&type=script&lang=js&"
import style0 from "./edit-article.vue?vue&type=style&index=0&id=73dc523e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc523e",
  null
  
)

export default component.exports